import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_Layout.scss'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as navigationActions } from './navigationLinksContainerReducerActions'
import HeaderContainer from './Header/HeaderContainer'
import FooterContainer from './Footer/FooterContainer'
import { Container, Row, Col } from 'react-bootstrap'
import BackButton from '../Buttons/BackButton'
import Sidebar from 'react-sidebar'
import SidebarContent from './SidebarContent'
import 'bootstrap/dist/css/bootstrap.min.css';
import classNames from 'classnames'

class Layout extends React.Component {
  static propTypes = {
    containerWell: PropTypes.bool,
    noContainerWell: PropTypes.bool,
    backButtonText: PropTypes.string,
    pageTitle: PropTypes.string,
    activeMenu: PropTypes.string,
    children: PropTypes.node.isRequired,
    setActiveMenu: PropTypes.func.isRequired,
    navigationLinksFetched: PropTypes.bool.isRequired,
    navigationLinks: PropTypes.object,
    sidebarOpen: PropTypes.bool.isRequired,
    publicPortalUrl: PropTypes.string.isRequired,
    onSetSidebarOpen: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  constructor (props) {
    super(props)

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.setActiveMenu = this.setActiveMenu.bind(this)
  }

  onSetSidebarOpen (open) {
    this.props.onSetSidebarOpen(open)
  }

  setActiveMenu (name) {
    this.props.setActiveMenu(name)
  }

  render () {
    var { className } = this.props
    if (!className) { className = '' }
    let gridStyling = this.props.containerWell ? styles['grid-with-well'] : styles.grid
    gridStyling += ' ' + styles['force-content-well-mobile']
    gridStyling += ' ' + className
    if (this.props.noContainerWell) {
      gridStyling += ' ' + styles['no-bottom-margin']
    }

    const rootGridStyles = this.props.backButtonText ? styles['root-grid-with-button'] : styles['root-grid']

    return (
      <div className={styles['background']}>
        <Sidebar
          sidebar={<SidebarContent
            setActiveMenu={this.setActiveMenu}
            activeMenu={this.props.activeMenu}
            signIn={this.props.navigationLinks?.SignIn}
            investPage={this.props.navigationLinks?.Invest}
            contactPage={this.props.navigationLinks?.ContactPage}
            searchPage={this.props.navigationLinks?.SearchPage}
            publicPortalUrl={this.props.publicPortalUrl}
            navigationLinksFetched={this.props.navigationLinksFetched}
            audiences={this.props.navigationLinks?.Audiences}
            mainMenu={this.props.navigationLinks?.MainMenu} />}
          shadow={false}
          touch={false}
          open={this.props.sidebarOpen}
          onSetOpen={this.onSetSidebarOpen}
          rootClassName={'sidebar-root-container'}
          contentClassName={'sidebar-content-container'}
          styles={{
            sidebar: {
              width: '80%'
            },
            content: {
              overflowX: 'hidden'
            }
          }}>
          <HeaderContainer />
          <div id='background'>
            <Container className={classNames(styles['grid'], rootGridStyles)}>
              <Row style={{ minHeight: '85vh' }} className="justify-content-center">
                <Col xs={12} sm={11} md={11} lg={11}>
                  {
                    this.props.backButtonText &&
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={styles['back-button'] + ' ' + styles['back-button-top']}>
                        <BackButton buttonText={this.props.backButtonText} />
                      </Col>
                    </Row>
                  }
                  {
                    this.props.pageTitle &&
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={styles['page-title']}>
                        <h2>{this.props.pageTitle}</h2>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={gridStyling}>
                      {this.props.children}
                    </Col>
                  </Row>
                  {
                    this.props.backButtonText &&
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={styles['back-button'] + ' ' + styles['back-button-bottom']}>
                        <BackButton buttonText={this.props.backButtonText} />
                      </Col>
                    </Row>
                  }
                </Col>
              </Row>

            </Container>
            <FooterContainer />
          </div>
        </Sidebar>
      </div>
    )
  }
}

const mapStateToProps = ({ navigationLinksContainer }) => {
  return {
    navigationLinks: navigationLinksContainer.navigationLinks,
    navigationLinksFetched: navigationLinksContainer.navigationLinksFetched,
    publicPortalUrl: navigationLinksContainer.publicPortalUrl,
    sidebarOpen: navigationLinksContainer.sidebarOpen,
    activeMenu: navigationLinksContainer.activeMenu
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    onSetSidebarOpen: navigationActions.set.sidebarOpen,
    setActiveMenu: navigationActions.set.activeMenu
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
